import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { viewsStateDispatcher, viewsState, siteSettingsState, combineStates, searchState} from '../store';
import { GenericViewer, StockFilter } from '.';
import ReactTooltip from 'react-tooltip';
import { NoResultsFound } from '../site';
import { translate } from '../services';
import { ViewSelector } from './ViewSelector';
import { GreyFilterEmptyIconNew, accessoriesIcon } from '../../style/images';
import { LightTooltip, SvgImage } from './SvgImage';
import { ProductItemDetail } from './ProductItemDetail';
import { Box, Grid, MenuItem, Select, Typography } from '@mui/material';
import { DropdownList } from 'react-widgets';
import productsData from './productData.json'
import { DataGrid } from '@mui/x-data-grid';
import SelectFilterMessage from '../site/components/screens/accessories/SelectFilterMessage';
import classNames from 'classnames';

export class ProductsViewerComponent extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      currentShow:"Products"
    };
  }
  useCustomLayout = item => this.props.useCustomLayout && this.props.useCustomLayout( item );

  predicate = ( item, value ) => item.name.includes( value ) || item.description.includes( value );

  onScroll = e => this.props.onScroll && this.props.onScroll( e );

  getCompleteProductsSet( products, metaData, selector ) {
    // ECQ-424 need access to the meta data to show the translation
    if ( 'allSatisfied' in metaData || ( 'bomItemFields' in metaData && metaData.bomItemFields.length > 0 ) ) {
      products.map( p =>{if(!p.configurableProduct && !p?.code?.startsWith('V')){
        return ({...p, ...metaData, isExpandable: this.isExpandable,noteByUser:''})
      }
    else{
      return ({...p,noteByUser:''});
    }})
    }
    return selector && selector.isFixedParts?products.filter(p=>!p.superCode).map(p => ({...p, isExpandable: this.isExpandable,noteByUser:''})):products.map(p => ({...p, isExpandable: this.isExpandable,noteByUser:''}));
  }
  
  isExpandable = item => {
    if ( item?.bomItems?.length ) {
      return true;
    } 
    return false;
  }

  onShowChange = (event)=>{
    this.setState({currentShow:event.target.value});
  }

  render() {
    const productData = productsData.map((p, id)=>{
      return{
              "id": id,
              "Image":p.imageLso?p.imageLso:"Not Availbale",
             "Product ID":p.name?p.name:"Not Availbale",
              "Product Description":p.productDescription?p.productDescription:"Not Availbale",
              }
    })
    const { hideHeader, products, tooltip, totalItems, view, metaData = {}, onConfigureRequest, onFilterChanged, isSearchPage, siteSettings, currentSelector, filterSelectors, hasStockFilter, className, isFilterSelected,fromConfiguratorSelector } = this.props;
    const { code = {} } = metaData;
    const { actualCode = null, matchingProduct = null } = code;
    const showStockFilter = siteSettings.showStockFilter && !isSearchPage && view != 'looseaccessories';

    if ( !products || !view ) {
      return null;
    }

    const foundItems = <><span className={fromConfiguratorSelector ? 'fromConfiguratorSelector-results' : 'result'}>{fromConfiguratorSelector ? `${translate( 'PRODUCTS')}: ${totalItems}` : translate( 'Results')}</span>
                     {fromConfiguratorSelector ? null : <span className='count'>{translate('({amount} {tr:product})', { amount: totalItems, product: totalItems === 1 ? 'item' : 'items' } )}</span>}</>
    const noResultsFound = <NoResultsFound show />;
    

    return totalItems === 0
      ? <Grid item container xl={12} height="100%">
        <div className={classNames("product-list", {"no-result-stock":showStockFilter})} style={{backgroundColor: 'transparent'}}>
        { !hideHeader &&showStockFilter&& <div className="product-header">
          <div className="product-header-title">
            <div className="total-size">
              <LightTooltip title={!tooltip || tooltip.length===0 ? null : 
                  tooltip.map(t=>t) 
                  }>
                <span className="total-size-content">
                  <span data-tip data-for="selectedFilters">{ foundItems }</span>
                </span>
              </LightTooltip>
              { actualCode && <span className="code-request">
                <span>
                  { actualCode }
                  { matchingProduct && `( ${ matchingProduct } )` }
                </span>
                <SvgImage
                  className="search-icon"
                  source={ accessoriesIcon }
                  onClick={ onConfigureRequest }
                  disabled={ matchingProduct === null }
                />
              </span> }
            </div>
          </div>
          {showStockFilter && <StockFilter isSearchPage={isSearchPage} hasStockFilter={hasStockFilter} currentSelector={ currentSelector } filterSelectors={ filterSelectors } active={true}/>}
        </div> }
          {!this.props?.looseAccesories ? 
          <NoResultsFound show isSearchPage={this.props.isSearchPage} isProductPage={this.props.isProductPage} currentSelector={this.props.currentSelector}/>
          :
          <>
            {isFilterSelected ? (
              <SelectFilterMessage
                heading="No data found."
                message="There are no accessories found for your request. Please try to change the values in filters"
                icon={GreyFilterEmptyIconNew}
              />
            ) : (
              <SelectFilterMessage
                forMobile = {{heading:"No data found.", message:'Please select filters first to see the accessories'}}
                forDesktop = {{heading:null, message:"Please select filters at the top first to see the accessories"}}
                icon={GreyFilterEmptyIconNew}
              />
            )}
          </>
          }
          {/* <NoResultsFound show isSearchPage={this.props.isSearchPage} isProductPage={this.props.isProductPage} currentSelector={this.props.currentSelector}/> */}
        </div>     
      </Grid>
      : <div className="product-list" style={{overflow:"unset"}}>
        { !hideHeader && <div className="product-header">
          <div className="product-header-title">
            <div className="total-size">
              <LightTooltip title={!tooltip || tooltip.length===0 ? null : 
                  tooltip.map(t=>t) 
                  }>
                <span className="total-size-content">
                  <span data-tip data-for="selectedFilters">{ foundItems }</span>
                </span>
              </LightTooltip>
              { actualCode && <span className="code-request">
                <span>
                  { actualCode }
                  { matchingProduct && `( ${ matchingProduct } )` }
                </span>
                <SvgImage
                  className="search-icon"
                  source={ accessoriesIcon }
                  onClick={ onConfigureRequest }
                  disabled={ matchingProduct === null }
                />
              </span> }
            </div>
          </div>
          {showStockFilter&&<StockFilter isSearchPage={isSearchPage} hasStockFilter={hasStockFilter} currentSelector={ currentSelector } filterSelectors={ filterSelectors } active={false} />}
          <ViewSelector view={ view } />
          {/* {this.props.resetHeader && <>{this.props.resetHeader.map(e=>e.customHeader)}</>} */}
        </div> }
        <GenericViewer
          noItemsFound={ noResultsFound }
          view={ view }
          onScroll={ this.onScroll }
          useCustomLayout={ this.useCustomLayout }
          predicate={ this.predicate }
          items={ this.getCompleteProductsSet( products, metaData,currentSelector?.selector ) }
          onFilterChanged={ onFilterChanged }
          detailTemplate={ ProductItemDetail }
          isExpandable={ this.isExpandable }
          className = {className}
          currentSelector={this.props.currentSelector}
          isLoading={this.props.isLoading}
          currentView= { this.props.currentView }
          template = {this.props.template}
          fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
        />
      </div>;
  }
}

ProductsViewerComponent.propTypes = {
  hideHeader: PropTypes.bool,
  onScroll: PropTypes.func,
  products: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  tooltip: PropTypes.oneOfType( [PropTypes.node, PropTypes.arrayOf( PropTypes.node )] ),
  totalItems: PropTypes.number.isRequired,
  useCustomLayout: PropTypes.func,
  view: PropTypes.string.isRequired,
  metaData: PropTypes.shape( { code: PropTypes.shape( {} ) } ),
  isSearchPage: PropTypes.bool,
  onConfigureRequest: PropTypes.func,
  onFilterChanged: PropTypes.func,
  isFilterSelected: PropTypes.bool,
  looseAccesories: PropTypes.bool,
};

ProductsViewerComponent.defaultProps = {
  metaData: {},
  isSearchPage: false,
};

export const ProductsViewer = connect( combineStates( viewsState, siteSettingsState, searchState), viewsStateDispatcher )( ProductsViewerComponent );